var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    className: "credit-card_svg__bi credit-card_svg__bi-credit-card-fill",
    viewBox: "0 0 16 16"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M0 4a2 2 0 012-2h12a2 2 0 012 2v1H0zm0 3v5a2 2 0 002 2h12a2 2 0 002-2V7zm3 2h1a1 1 0 011 1v1a1 1 0 01-1 1H3a1 1 0 01-1-1v-1a1 1 0 011-1"
  })));
}
export default SvgCreditCard;